import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/app/components/ui/dialog';

interface ShortcutOverlayProps {
  open: boolean;
  onClose: () => void;
}

const SHORTCUTS: { key: string; description: string }[] = [
  { key: '/', description: 'Focus search input' },
  { key: 'Esc', description: 'Clear selection' },
  { key: 'D', description: 'Open Dispatch dialog' },
  { key: 'Ctrl+Z', description: 'Undo latest board action' },
  { key: 'Ctrl+Y', description: 'Redo latest undone board action' },
  { key: '?', description: 'Toggle this shortcut overlay' },
  { key: 'Shift+Click', description: 'Multi-select technicians' },
];

export function ShortcutOverlay({ open, onClose }: ShortcutOverlayProps) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts</DialogTitle>
          <DialogDescription>
            Quick actions available on the H3ightboard.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1 py-2">
          {SHORTCUTS.map((s) => (
            <div
              key={s.key}
              className="flex items-center justify-between py-2 px-1"
            >
              <span className="text-sm text-gray-700">{s.description}</span>
              <kbd className="inline-flex items-center rounded border border-gray-300 bg-gray-50 px-2 py-0.5 text-xs font-mono font-medium text-gray-600">
                {s.key}
              </kbd>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
